import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ibmQradar = defineConnector({
  identifier: "ibmQradar",
  name: "IBM QRadar",
  tagLine: "Security information and event management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) => headerAuth([{ name: "SEC", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your QRadar API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your QRadar console. Navigate to **Admin** > **Authorized Services** and create a new authorized service token.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "hostname",
          label: "QRadar host",
          placeholder: "qradar.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
          helperText: "The hostname of your QRadar console.",
        },
        {
          kind: "input",
          label: "SEC token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The authorized service token from QRadar.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/system/about`,
  },
});
